module.exports = __webpack_public_path__ + "img/kalpinsky.0418e4c5.jpg";